<template>
  <!-- 司机管理 -->
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class=" formItemBox">
               <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder="" v-model="searchFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <el-input  placeholder="" v-model="searchFrom.mobile"></el-input>
              </el-form-item>
                 <el-form-item label="身份证号:" prop="identityNo">
                <el-input  placeholder="" v-model="searchFrom.identityNo"></el-input>
              </el-form-item>
                <el-form-item label="所属单位/个人:" prop="driverTenantName">
                <el-input  placeholder="" v-model="searchFrom.driverTenantName"></el-input>
              </el-form-item>
              <el-form-item label="驾驶证档案号:" prop="certificateNum">
              <el-input  placeholder="" v-model="searchFrom.certificateNum"></el-input>
              </el-form-item>
              <br>
                <el-form-item label="从业资格证号:"  prop="qualificationNum">
                <el-input  placeholder="" v-model="searchFrom.qualificationNum"></el-input>
              </el-form-item>
               <el-form-item label="起始地址:" prop="startArea">
                <el-input  placeholder="" v-model="searchFrom.startArea"></el-input>
              </el-form-item>
              <el-form-item label="目的地址:" prop="endArea">
                <el-input  placeholder="" v-model="searchFrom.endArea"></el-input>
              </el-form-item>
             <el-form-item label="创建时间:" prop="createTimes">
                <el-date-picker
                      v-model="searchFrom.createTimes"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                ></el-date-picker>
            </el-form-item>
            <!-- <el-form-item label="从业资格证是否过期:" prop="qualificationOverdue" label-width="200">
                <el-select placeholder="请选择" v-model="searchFrom.qualificationOverdue">
                  <el-option
                    v-for="item in qualificationOverdueArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item> -->
             <!-- <el-form-item label="身份证是否过期:" prop="identityOverdue" label-width="150">
                <el-select placeholder="请选择" v-model="searchFrom.identityOverdue">
                  <el-option
                    v-for="item in identityOverdueArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item> -->
             <!-- <el-form-item label="驾驶证是否过期:" prop="appendixOverdue" label-width="150">
                <el-select placeholder="请选择" v-model="searchFrom.appendixOverdue">
                  <el-option
                    v-for="item in appendixOverdueArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item> -->
        </div>
       <div class="searchBtnBox">
         <el-form-item btnCode="00IP001B000"  v-if="btnFlg[0]">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="00IP001B001"  v-if="btnFlg[1]">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="00IP001B002"  v-if="btnFlg[2]">
            <el-button type="primary"  @click="addDeiver">新增</el-button>
          </el-form-item>
          <el-form-item btnCode="00IP001B003"  v-if="btnFlg[3]">
            <el-button type="danger" @click="delDeiver">删除</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="takeGoods">导入</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' class="tableComent"
       @row-click="handleRowClick" height="100%"   style="width: 100%" center border :cell-style="getCellStyle">
         <el-table-column type="selection" width="50" align="center" fixed></el-table-column>
          <el-table-column type="index" prop="date" width="50" label="序号" align="center" fixed></el-table-column>
          <el-table-column label="操作" width="100" align="center" fixed>
            <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" btnCode="009M0U0200" v-if="btnFlg[4]" @click="modifyDeiver(scope.row)">修改</el-button>
                <el-button type="text" size="mini" @click="lookFn(scope.row)">查看</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="auditStatus" label="审核状态" >
              <!-- {{[ "待审核", "审核通过", "审核驳回" ][scope.row.auditStatus-1]}} -->
            <template scope="scope">
              <div>
                <span v-show="scope.row.auditStatus == '1'" class="">待审核</span>
                <span v-show="scope.row.auditStatus == '2'" class="greenStyle">审核通过</span>
                <span v-show="scope.row.auditStatus == '3'" class="redStyle">审核驳回</span>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column property="accountStatus" label="开通状态" >
            <template scope="scope">
              {{[  "未开通","已开通" ][scope.row.accountStatus-1]}}
            </template>
          </el-table-column> -->
          <el-table-column prop="name" width="100" :formatter="emptyFn" :show-overflow-tooltip="true" label="司机姓名"></el-table-column>
          <el-table-column prop="identityNo" width="180" :formatter="emptyFn" label="身份证号"></el-table-column>
          <el-table-column prop="mobile" width="120" :formatter="emptyFn" label="联系电话"></el-table-column>
          <el-table-column prop="licenseNum" width="150" :show-overflow-tooltip="true" :formatter="emptyFn" label="驾驶证号"></el-table-column>
          <el-table-column prop="qualificationNum" width="170" :show-overflow-tooltip="true" :formatter="emptyFn" label="道路运输从业资格证号"></el-table-column>
          <el-table-column prop="identityExpiringDate" width="120" label="身份证有效期"></el-table-column>
          <el-table-column prop="quasiDrivingModel" width="100" label="准驾车型"></el-table-column>
          <el-table-column prop="issueAuthority" width="170" :show-overflow-tooltip="true" label="驾驶证发证机关"></el-table-column>
          <el-table-column prop="validPeriodFrom" width="110" :formatter="dateFormat" label="驾照起始日期"></el-table-column>
          <el-table-column prop="validPeriodTo" width="110" label="驾照截止日期"></el-table-column>
          <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat" label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="开通账号" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="kztzVisible" @close="closeDialog" width="400px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="ktzhFrom" ref="ktzhFrom" class="demo-form-inline jiaoyan" label-width="110px" size="mini">
        <div class="inpBox">
              <el-form-item label="账号:" prop="account">
                <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="ktzhFrom.account"></el-input>
              </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="kztzVisible = false">取 消</el-button>
        <el-button type="primary" @click="KTsaveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 司机的新建修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogVisible" @close="closeDialogB('addFrom')" width="1200px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="180px" size="mini" v-if="dialogVisible">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
              <el-form-item label="身份证号:" prop="identityNo">
                <el-input  placeholder="" :class="{ 'disabled': !isAdd }"  :readonly="!isAdd" @blur="CPHfn()"   maxlength="18" v-model.trim="addFrom.identityNo"></el-input>
              </el-form-item>
               <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder="" :class="{ 'disabled': !isAdd }"  :readonly="!isAdd" maxlength="11" v-model.trim="addFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="addFrom.mobile"></el-input>
              </el-form-item>
               <!-- <el-form-item label="司机所属:" prop="driverClassify">
                <el-select placeholder="请选择" v-model="addFrom.driverClassify" @change="driverClassifyChange">
                  <el-option
                    v-for="item in vehicleSS"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
             </el-form-item>
              <el-form-item label="所属单位/个人:"  prop="driverTenant" v-if="addFrom.driverClassify==1" key="1">
                <el-select placeholder="请选择"  filterable allow-create  remote reserve-keyword  :remote-method="remoteMethod"
                default-first-option v-model="addFrom.driverTenant" value-key="tenantCode" >
                  <el-option
                    v-for="(item,index) in ssdw"
                    :key="index"
                    :label="item.tenantName"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="所属单位/个人:" prop="driverTenantName" v-if="addFrom.driverClassify==2" key="2">
                <el-input  placeholder="" v-model="addFrom.driverTenantName"  maxlength="11"></el-input>
              </el-form-item> -->
              <el-form-item label="驾驶证号:" prop="licenseNum">
                <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.licenseNum" ></el-input>
              </el-form-item>
                <el-form-item label="驾驶证档案号:" prop="certificateNum">
                <el-input  placeholder="" maxlength="50" v-model.trim="addFrom.certificateNum"></el-input>
              </el-form-item>
               <el-form-item label="身份证开始日期:" :rules="[{ required: isBitian, message: '请选择身份证开始日期', trigger: 'blur' } ]">
                <el-date-picker
                  v-model="addFrom.identityStratDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
               <el-form-item label="身份证是否长期:" prop="sfzcq " class="ziti" >
                  <template >
                    <div style="width:150px">
                       <el-radio-group v-model="addFrom.sfzcq">
                        <el-radio :label="1" >是</el-radio>
                        <el-radio :label="2">否</el-radio>
                      </el-radio-group>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item label="身份证有效期:" prop="identityExpiringDate" v-if="addFrom.sfzcq==2">
                <el-date-picker
                  v-model="addFrom.identityExpiringDate"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
              <el-form-item label="道路运输从业资格证:"  prop="qualificationNum">
                  <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.qualificationNum"></el-input>
                </el-form-item>
              <el-form-item label="准驾车型:" filterable prop="quasiDrivingModelArr" >
                <el-select placeholder="请选择" multiple v-model="addFrom.quasiDrivingModelArr">
                  <el-option
                    v-for="(item,index) in zjcx"
                    :key="index"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
             </el-form-item>
             <el-form-item label="驾驶证发证机关:"  prop="issueAuthority">
                <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.issueAuthority"></el-input>
              </el-form-item>
              <el-form-item label="驾照起始日期:" :rules="[{ required: isBitian, message: '请选择驾照起始日期', trigger: 'blur' } ]">
                <el-date-picker
                  v-model="addFrom.validPeriodFrom"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
                <el-form-item label="驾照是否长期:" prop="jzcq " class="ziti"  >
                  <template >
                    <div style="width:150px">
                       <el-radio-group v-model="addFrom.jzcq">
                        <el-radio :label=1 >是</el-radio>
                        <el-radio :label=2>否</el-radio>
                      </el-radio-group>
                    </div>
                  </template>
                </el-form-item>
                <el-form-item label="驾照结束日期:" prop="validPeriodTo" v-if="addFrom.jzcq==2">
                <el-date-picker
                  v-model="addFrom.validPeriodTo"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
                </el-form-item>
                 <el-form-item label="从业资格证生效日期:" :rules="[{ required: isBitian, message: '请选择从业资格证生效日期', trigger: 'blur' } ]">
                <el-date-picker
                  v-model="addFrom.qualificationLicenceStartDate"
                  format="yyyy-MM-dd"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="从业资格证失效日期:" :rules="[{ required: isBitian, message: '请选择从业资格证失效日期', trigger: 'blur' } ]">
                <el-date-picker
                  v-model="addFrom.qualificationLicenceEndDate"
                   format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="选择日期时间"
                ></el-date-picker>
              </el-form-item>
                <div style="display:flex;">
                  <el-form-item label="行政区域:" :class="{'diqu':true,'is-required':isBitian}" prop="xname" >
                    <shengShiXian :rowData="this.addFrom" @handleChange="handleChange" v-if="flag"></shengShiXian>
                  </el-form-item>
                  <el-form-item label="身份证地址:" class="diqu" prop="address" >
                    <el-input  placeholder=""  maxlength="100" v-model.trim="addFrom.address"></el-input>
                  </el-form-item>
                </div>
               <div class="box" v-if="newImgFlag&&isBitian">
                <div class="imgBox">
                    <uploadImg :img='img' key="0" @remove ='handleRemove'  @change ='imgPreview'></uploadImg>
                    <h6 class="is-need">身份证正面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img1'  key="1"  @remove ='handleRemove1'  @change ='imgPreview1'></uploadImg>
                    <h6  class="is-need">身份证背面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img2'  key="2"  @remove ='handleRemove2'  @change ='imgPreview2'></uploadImg>
                    <h6  class="is-need">驾驶证正面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img3' key="3"   @remove ='handleRemove3'  @change ='imgPreview3'></uploadImg>
                    <h6  class="is-need">驾驶证背面</h6>
                </div>
                <div class="imgBox">
                    <uploadImg :img='img4' key="4"   @remove ='handleRemove4'  @change ='imgPreview4'></uploadImg>
                    <h6  class="is-need">道路运输从业资格证</h6>
                </div>
              </div>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确定</el-button>
      </span>
    </el-dialog>
     <!-- 查看 -->
    <el-dialog title="查看详情" :close-on-click-modal="false" class="detailBox" :close-on-press-escape="false" :visible.sync="dialoglook" @close="closeDialog" width="1120px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="150px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
              <el-form-item label="身份证号:" prop="identityNo">
                <span>{{addFrom.identityNo}}</span>
              </el-form-item>
               <el-form-item label="司机姓名:" prop="name">
                <span>{{addFrom.name}}</span>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <span>{{addFrom.mobile}}</span>
              </el-form-item>
               <!-- <el-form-item label="司机所属:" prop="driverClassify">
               <span> {{[ "市场司机", "自家司机" ][addFrom.driverClassify-1]}}</span>
             </el-form-item> -->
              <el-form-item label="所属单位/个人:" prop="driverTenantName">
               <span>{{addFrom.driverTenantName}}</span>
              </el-form-item>
              <el-form-item label="驾驶证号:" prop="licenseNum">
               <span>{{addFrom.licenseNum}}</span>
              </el-form-item>
               <el-form-item label="身份证有效期:" prop="identityExpiringDate">
                 <span>{{addFrom.identityExpiringDate}}</span>
                </el-form-item>
                <el-form-item label="驾驶证档案号:" prop="certificateNum">
                  <span>{{addFrom.certificateNum}}</span>
              </el-form-item>
                <el-form-item label="准驾车型:" prop="quasiDrivingModel" >
                 <span>{{addFrom.quasiDrivingModel}}</span>
                </el-form-item>
                <el-form-item label="驾驶证发证机关:" prop="issueAuthority" >
                 <span>{{addFrom.issueAuthority}}</span>
                </el-form-item>
                <el-form-item label="驾照起始日期:" prop="validPeriodFrom" >
                 <span>{{addFrom.validPeriodFrom|dateFormat1}}</span>
                </el-form-item>
                <el-form-item label="驾照截止日期:" prop="validPeriodTo">
                 <span>{{addFrom.validPeriodTo}}</span>
                </el-form-item>
              <el-form-item label="道路运输从业资格证:" label-width="200" prop="qualificationNum">
               <span style="width:560px">{{addFrom.qualificationNum}}</span>
              </el-form-item>
              <el-form-item label="行政区域:" prop="xname" >
               <span style="width:200px">{{addFrom.provinceName}}-{{addFrom.cityName}}-{{addFrom.areaName}}</span>
              </el-form-item>
              <el-form-item label="身份证地址:" label-width="200" prop="address">
               <span style="width:300px">{{addFrom.address}}</span>
              </el-form-item>
              <!-- <el-form-item label="常走路线:" prop="useLines">
               <div style="width:560px">{{addFrom.useLines}}</div>
              </el-form-item> -->
               <div class="box" v-if="isBitian">
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.identityPhoto1Url"
                      :preview-src-list="[addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl]">
                    </el-image>
                    <h6 class="is-need">身份证正面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.identityPhoto2Url"
                      :preview-src-list="[addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url]">
                    </el-image>
                    <h6  class="is-need">身份证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.appendix1Url"
                      :preview-src-list="[addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证正面</h6>
                </div>
                <div class="imgBox">
                     <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.appendix2Url"
                      :preview-src-list="[addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.qualificationPhotoUrl"
                      :preview-src-list="[addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url]">
                    </el-image>
                    <h6  class="is-need">道路运输从业资格证</h6>
                </div>
              </div>

        </div>
      </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialoglook = false">关闭</el-button>
      </span>
    </el-dialog>
     <!-- 记录 -->
    <el-dialog title="记录" :close-on-click-modal="false" class="detailBox" :close-on-press-escape="false" :visible.sync="recordVisible" @close="closeDialog" width="500px" center>
      <span>
        <el-timeline>
          <el-timeline-item  v-for="(activity, index) in activities" :key="index" :color="activities.length-1 ? '#0bbd87' : ''">
            <p>审核操作：
              <span v-if="activity.zzauditStatus == '1'">待审核</span>
              <span v-if="activity.zzauditStatus == '2'">审核通过</span>
              <span v-if="activity.zzauditStatus == '3'">审核驳回</span>
            </p>
            <p v-if="activity.zzauditStatus == '3'">驳回原因：{{activity.nopassReason}}</p>
            <p>审核人：{{activity.auditUser}}</p>
            <p>审核时间：{{activity.auditTime|dateFormat1}}</p>
          </el-timeline-item>
        </el-timeline>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordVisible = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
// import {
//   zzauditHistoryList // 记录
// } from '@/api/consignment'
import shengShiXian from '@/components/common/shengShiXian.vue'
import { getBtn } from '@/utils/getButton'
import uploadImg from '@/components/uploadImg.vue'
import { compressImage } from '@/utils/compressImage'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import { selectTenantListByName } from '@/api/soc-customer'
import { cDlist, cDadd, cDupdate, cDdelete, getCDriverInfo, openAccount,
  detailDriver, CDBadd, CDBupdate, updateDefault, CDBlist, CDBdelete, getDictionary, tOverdueSetList } from '@/api/vgs-driver2.0'
import DonMessage from '@/utils/message'
export default {
  components: {
    uploadImg, shengShiXian
  },
  data () {
    return {
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: '500px',
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      FKfrom: {
        SKlist: []
      },
      isEdits: [],
      isAdd: false,
      tableList: [],
      loading: false,
      addFrom: { jzcq: 2, sfzcq: 2 },
      ktzhFrom: {},
      title: '新建司机信息',
      img: [],
      img1: [],
      img2: [],
      img3: [],
      img4: [],
      imgList: [],
      newImgFlag: false,
      flag: true,
      rules: {
        name: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        xname: [
          { required: this.isBitian, message: '请选择省市县', trigger: 'blur' }
        ],
        driverClassify: [
          { required: true, message: '请选择司机所属', trigger: ['blur', 'change'] }
        ],
        identityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        account: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        licenseNum: [
          { required: this.isBitian, message: '请输入驾驶证号', trigger: 'blur' }
        ],
        certificateNum: [
          { required: this.isBitian, message: '请输入驾驶证号档案号', trigger: 'blur' }
        ],
        qualificationNum: [
          { required: this.isBitian, message: '请输入从业资格证号', trigger: 'blur' }
        ],
        driverTenantName: [
          { required: this.isBitian, message: '请输入所属单位/个人', trigger: 'blur' }
        ],
        driverTenant: [
          { required: this.isBitian, message: '请输入所属单位/个人', trigger: 'blur' }
        ],
        quasiDrivingModelArr: [
          { required: true, message: '请选择准驾车型', trigger: 'blur' }
        ],
        issueAuthority: [
          { required: this.isBitian, message: '请输入驾驶证发证机关', trigger: 'blur' }
        ],
        identityExpiringDate: [
          { required: this.isBitian, message: '请选择身份证有效期', trigger: 'blur' }
        ],
        validPeriodFrom: [
          { required: this.isBitian, message: '请选择驾照起始日期', trigger: 'blur' }
        ],
        validPeriodTo: [
          { required: this.isBitian, message: '请选择驾照结束日期/个人', trigger: 'blur' }
        ],
        address: [
          { required: this.isBitian, message: '请输入身份证地址', trigger: 'blur' }
        ],
        qualificationLicenceStartDate: [
          { required: this.isBitian, message: '请选择从业资格证生效日期', trigger: 'blur' }
        ],
        qualificationLicenceEndDate: [
          { required: this.isBitian, message: '请选择从业资格证失效日期', trigger: ['blur', 'change'] }
        ]
      },
      vehicleSS: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '单位'
        },
        {
          value: 2,
          label: '个人'
        }
      ],
      zjcx: ['A1', 'A2', 'A3', 'B1', 'B2', 'C1', 'C2', 'C3', 'C4', 'D', 'E'],
      total: 0,
      value2: '',
      ids: [],
      dialogVisible: false,
      kztzVisible: false,
      dialoglook: false,
      disabled: false,
      hideUploadEditA: false,
      hideUploadEditB: false,
      hideUploadEditC: false,
      hideUploadEditD: false,
      ssdw: [], // 所属单位列表
      btnFlg: [],
      btnIdArr: ['00IP001B000', '00IP001B001', '00IP001B002',
        '00IP001B003', '00IP001B004', '00IP001B005', '00IP001B006'],
      qualificationOverdueArr: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '已过期'
        }
      ],
      identityOverdueArr: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '已过期'
        }
      ],
      appendixOverdueArr: [
        {
          value: '',
          label: '请选择'
        },
        {
          value: 1,
          label: '正常'
        },
        {
          value: 2,
          label: '已过期'
        }
      ],
      recordVisible: false,
      activities: [],
      isBitian: false,
      bjData: {}
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/driverTow')
    this.getList(this.searchFrom)
    getDictionary({ groupName: 'certificate_flag' }).then(res => {
      if (res) {
        this.isBitian = res.value1 == 1
      }
    })
    tOverdueSetList().then(res => {
      if (res.length > 0) {
        this.bjData = res[0]
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    getCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (column.property == 'identityExpiringDate' && row.identityDays < this.bjData.identityDays) {
        return { background: '#FEB0A4' }
      }
      if (column.property == 'validPeriodTo' && row.licenseDays < this.bjData.licenseDays) {
        return { background: '#FEB0A4' }
      }
      if (column.property == 'qualificationTo' && row.qualificationDays < this.bjData.qualificationDays) {
        return { background: '#FEB0A4' }
      }
    },
    // 所属单位
    remoteMethod (query) {
      console.log(222)
      if (query !== '') {
        selectTenantListByName({ tenantNameLike: query }).then(res => {
          this.ssdw = res
        })
      }
    },
    // 所属切换
    driverClassifyChange () {
      if (this.addFrom.driverClassify == 2) {
        this.$set(this.addFrom, 'driverTenantName', this.addFrom.name)
        this.$set(this.addFrom, 'driverTenantCode', '')
      }
    },
    // 添加保存
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.addFrom.driverClassify == 1) {
          //   if (typeof (this.addFrom.driverTenant) == 'string') {
          //     this.addFrom.driverTenantName = this.addFrom.driverTenant
          //     this.addFrom.driverTenantCode = ''
          //   } else {
          //     this.addFrom.driverTenantName = this.addFrom.driverTenant.tenantName
          //     this.addFrom.driverTenantCode = this.addFrom.driverTenant.tenantCode
          //   }
          // }
          this.addFrom.driverClassify = 1
          if (this.addFrom.sfzcq == 1) {
            this.addFrom.identityExpiringDate = '长期'
          }
          if (this.addFrom.jzcq == 1) {
            this.addFrom.validPeriodTo = '长期'
          }
          if (this.addFrom.quasiDrivingModelArr) {
            this.addFrom.quasiDrivingModel = this.addFrom.quasiDrivingModelArr.join(',')
          }

          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(this.addFrom))
          if (this.isBitian) {
            if (this.imgList.length == 5) {
              let arr = []
              for (let i = 0; i < this.imgList.length; i++) {
                if (this.imgList[i]) {
                  if (this.imgList[i] != 1) {
                    arr.push({ img: this.imgList[i], index: i })
                  }
                } else {
                  this.$alert('请上传证件信息', '系统提示')
                  return
                }
              }
              if (arr.length > 0) {
                for (let i = 0; i < arr.length; i++) {
                  let a = i
                  compressImage(arr[i].img.url, arr[i].img.raw, {
                    width: 1000
                  }).then(result => {
                    imgfile.append('file' + arr[a].index, result)// result即为压缩后的结果
                    if (a == arr.length - 1) {
                      if (this.isAdd) {
                        this.addJK(imgfile)
                      } else {
                        this.xiugaiJK(imgfile)
                      }
                    }
                  })
                }
              } else {
                if (this.isAdd) {
                  this.addJK(imgfile)
                } else {
                  this.xiugaiJK(imgfile)
                }
              }
            } else {
              this.$alert('请上传证件信息', '系统提示')
            }
          } else {
            if (this.isAdd) {
              this.addJK(imgfile)
            } else {
              this.xiugaiJK(imgfile)
            }
          }
        } else {
          return false
        }
      })
    },
    // 图片上传
    handleRemove (data) {
      this.imgList[0] = null
    },
    imgPreview (data) {
      this.imgList[0] = data[0]
    },
    handleRemove1 (data) {
      this.imgList[1] = null
    },
    imgPreview1 (data) {
      this.imgList[1] = data[0]
    },
    handleRemove2 (data) {
      this.imgList[2] = null
    },
    imgPreview2 (data) {
      this.imgList[2] = data[0]
    },
    handleRemove3 (data) {
      this.imgList[3] = null
    },
    imgPreview3 (data) {
      this.imgList[3] = data[0]
    },
    handleRemove4 (data) {
      this.imgList[4] = null
    },
    imgPreview4 (data) {
      this.imgList[4] = data[0]
    },
    // 添加付款信息
    addHkFn () {
      if (this.FKfrom.driverId) {
        if (this.FKfrom.SKlist.length >= 3) {
          this.$alert('最多只能添加三条付款信息', '系统提示')
        } else if (!this.isEdits.every(item => { return !item })) {
          this.$alert('页面有未保存的收款信息，请先处理', '系统提示')
        } else {
          this.FKfrom.SKlist.push({ key: this.FKfrom.SKlist.length })
          this.isEdits.push(true)
        }
      } else {
        this.$alert('请先保存司机基本信息', '系统提示')
      }
    },
    // 删除银行卡
    delFn (row, index) {
      if (row.id) {
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          CDBdelete({ id: row.id }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getBankList()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      } else {
        this.FKfrom.SKlist.splice(index, 1)
        this.isEdits.splice(index, 1)
      }
    },
    // 设置默认
    setMfn (row, index) {
      if (!this.isEdits.every(item => { return !item })) {
        this.$alert('页面有未保存的收款信息，请先处理', '系统提示')
      } else {
        this.$confirm('是否将该卡设置为默认?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          updateDefault({ id: row.id, isDefault: 1 }).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getBankList()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    // 付款修改
    FKedit (row, index) {
      if (this.FKfrom.driverId) {
        if (!this.isEdits.every(item => { return !item })) {
          this.$alert('页面有未保存的收款信息，请先处理', '系统提示')
        } else {
          this.$set(this.isEdits, index, true)
        }
      } else {
        this.$alert('请先保存司机基本信息', '系统提示')
      }
    },
    // 付款保存
    FKsave (row, index) {
      let that = this
      that.$refs.FKfrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (row.id) {
            row.driverId = this.FKfrom.driverId
            CDBupdate(row).then(res => {
              loading.close()
              this.getBankList()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            row.driverId = this.FKfrom.driverId
            CDBadd(row).then(res => {
              loading.close()
              this.getBankList()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        }
      })
    },
    // 获取银行卡列表
    getBankList () {
      CDBlist({ driverId: this.FKfrom.driverId }).then(res => {
        this.FKfrom.SKlist = res
        this.isEdits = []
        res.forEach(item => {
          this.isEdits.push(false)
        })
      })
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.driverClassify = 1
      cDlist(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 地区选中
    handleChange (value) {
      if (value) {
        this.addFrom.provinceCode = value[0].areaCode
        this.addFrom.cityCode = value[1].areaCode
        this.addFrom.areaCode = value[2].areaCode
        this.addFrom.provinceName = value[0].name
        this.addFrom.cityName = value[1].name
        this.addFrom.areaName = value[2].name
        this.$set(this.addFrom, 'xname', value[0].name)
      }
    },

    // 开通账号
    ktzhFn (row) {
      this.kztzVisible = true
      this.ktzhFrom.driverId = row.id
      this.$set(this.ktzhFrom, 'account', row.mobile)
    },
    KTsaveFn () {
      this.$refs.ktzhFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          openAccount(this.ktzhFrom).then(res => {
            loading.close()
            this.kztzVisible = false
            this.$message({
              message: '开通成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },

    // 司机添加
    addDeiver () {
      this.title = '新建司机信息'
      this.dialogVisible = true
      this.isAdd = true
      this.newImgFlag = true
      this.addFrom = { jzcq: 2, sfzcq: 2 }
      this.flag = true
      this.img = []
      this.img1 = []
      this.img2 = []
      this.img3 = []
      this.img4 = []
    },
    // 获取司机信息
    CPHfn () {
      if (this.isAdd) {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        this.newImgFlag = false
        getCDriverInfo({ identityNo: this.addFrom.identityNo }).then(res => {
          loading.close()
          if (res.id) {
            this.addFrom = res
            if (this.addFrom.driverClassify == 1) {
              if (res.driverTenantCode == '') {
                this.$set(this.addFrom, 'driverTenant', res.driverTenantName)
              } else {
                this.$set(this.addFrom, 'driverTenant', { tenantCode: res.driverTenantCode, tenantName: res.driverTenantName })
              }
            }
            this.$set(this.addFrom, 'quasiDrivingModelArr', res.quasiDrivingModel.split(','))
            if (res.identityPhoto1Url) {
              this.$set(this.img, 0, { status: 'ready', url: res.identityPhoto1Url })
              this.$set(this.imgList, 0, 1)
            }
            if (res.identityPhoto2Url) {
              this.$set(this.img1, 0, { status: 'ready', url: res.identityPhoto2Url })
              this.$set(this.imgList, 1, 1)
            }
            if (res.appendix1Url) {
              this.$set(this.img2, 0, { status: 'ready', url: res.appendix1Url })
              this.$set(this.imgList, 2, 1)
            }
            if (res.appendix2Url) {
              this.$set(this.img3, 0, { status: 'ready', url: res.appendix2Url })
              this.$set(this.imgList, 3, 1)
            }
            if (res.qualificationPhotoUrl) {
              this.$set(this.img4, 0, { status: 'ready', url: res.qualificationPhotoUrl })
              this.$set(this.imgList, 4, 1)
            }
            this.newImgFlag = true
            this.FKfrom.SKlist = res.cDriverBankCardList
            this.isEdits = []
            res.cDriverBankCardList.forEach(item => {
              this.isEdits.push(false)
            })
          } else {
            let identityNo = this.addFrom.identityNo
            this.addFrom = {
              identityNo: identityNo
            }
            this.imgList = []
            this.img = []
            this.img1 = []
            this.img2 = []
            this.img3 = []
            this.img4 = []
            this.newImgFlag = true
          }
          this.$set(this.addFrom, 'licenseNum', this.addFrom.identityNo)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    // 查看
    lookFn (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      detailDriver({ driverId: row.id }).then(res => {
        loading.close()
        this.addFrom = res
        this.FKfrom.SKlist = res.cDriverBankCardList
        this.dialoglook = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 修改
    modifyDeiver (row) {
      this.title = '修改司机信息'
      if (this.$refs.addFrom !== undefined) {
        this.$refs.addFrom.resetFields()
      }
      this.addFrom = {}
      this.ktzhFrom = {}
      this.$refs.table.clearSelection()
      this.isEdits = []
      this.rules1 = []
      this.FKfrom.SKlist = []
      this.FKfrom.driverId = null
      this.img = []
      this.img1 = []
      this.img2 = []
      this.img3 = []
      this.img4 = []
      this.newImgFlag = false
      this.flag = false
      this.flag = true
      this.addFrom = JSON.parse(JSON.stringify(row))

      this.dialogVisible = true
      this.isAdd = false
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })

      detailDriver({ driverId: row.id }).then(res => {
        loading.close()
        this.addFrom = JSON.parse(JSON.stringify(row))
        this.$set(this.addFrom, 'xname', this.addFrom.provinceName)
        this.$set(this.addFrom, 'quasiDrivingModelArr', row.quasiDrivingModel.split(','))
        // if (this.addFrom.driverClassify == 1) {
        //   if (row.driverTenantCode == '') {
        //     this.$set(this.addFrom, 'driverTenant', row.driverTenantName)
        //   } else {
        //     this.ssdw = [{ tenantCode: row.driverTenantCode, tenantName: row.driverTenantName }]
        //     this.$set(this.addFrom, 'driverTenant', { tenantCode: row.driverTenantCode, tenantName: row.driverTenantName })
        //   }
        // }
        if (row.identityPhoto1Url) {
          this.$set(this.img, 0, { status: 'ready', url: row.identityPhoto1Url })
          this.$set(this.imgList, 0, 1)
        }
        if (row.identityPhoto2Url) {
          this.$set(this.img1, 0, { status: 'ready', url: row.identityPhoto2Url })
          this.$set(this.imgList, 1, 1)
        }
        if (row.appendix1Url) {
          this.$set(this.img2, 0, { status: 'ready', url: row.appendix1Url })
          this.$set(this.imgList, 2, 1)
        }
        if (row.appendix2Url) {
          this.$set(this.img3, 0, { status: 'ready', url: row.appendix2Url })
          this.$set(this.imgList, 3, 1)
        }
        if (row.qualificationPhotoUrl) {
          this.$set(this.img4, 0, { status: 'ready', url: row.qualificationPhotoUrl })
          this.$set(this.imgList, 4, 1)
        }

        if (this.addFrom.identityExpiringDate == '长期') {
          this.$set(this.addFrom, 'sfzcq', 1)
          this.$set(this.addFrom, 'identityExpiringDate', null)
        } else {
          this.$set(this.addFrom, 'sfzcq', 2)
        }
        if (this.addFrom.validPeriodTo == '长期') {
          this.$set(this.addFrom, 'jzcq', 1)
          this.$set(this.addFrom, 'validPeriodTo', null)
        } else {
          this.$set(this.addFrom, 'jzcq', 2)
        }
        this.newImgFlag = true
        this.FKfrom.SKlist = res.cDriverBankCardList
        this.isEdits = []
        res.cDriverBankCardList.forEach(item => {
          this.isEdits.push(false)
        })
        this.FKfrom.driverId = res.id
        this.dialogVisible = true
        this.isAdd = false
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },

    // 添加接口
    addJK (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      cDadd(data).then(res => {
        loading.close()
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.addFrom.id = res.id
        this.FKfrom.driverId = res.id// 添加付款信息的时候用
        this.dialogVisible = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 修改接口
    xiugaiJK (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      cDupdate(data).then(res => {
        loading.close()
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.dialogVisible = false
        this.getList(this.searchFrom)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 删除
    delDeiver () {
      const selectData = this.$refs.table.selection
      if (selectData.length < 1) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        this.ids = []
        selectData.some(item => {
          this.ids.push(item.id)
        })
        this.$confirm('是否执行删除操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          cDdelete({ ids: this.ids }).then(res => {
            loading.close()
            this.$message({
              message: '删除成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }).catch(() => {

        })
      }
    },
    closeDialogB (formName) {
      // this.$refs[formName].resetFields()
      this.addFrom = {}
    },
    closeDialog () {

    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50,
        createTime: null
      }
    },
    record (row) {
      // zzauditHistoryList({
      //   drivercarId: row.id,
      //   drivercarFlg: '1'
      // }).then(res => {
      //   this.activities = res
      //   if (this.activities.length == 0) {
      //     DonMessage.error('暂无记录')
      //   } else {
      //     this.recordVisible = true
      //   }
      // }).catch(err => {
      //   DonMessage.error(err.message)
      // })
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.imgBox{
  display: flex;
  .item{
    display: flex;
     width: 50%;
     justify-content: space-around;
  }
  /deep/ .hide .el-upload--picture-card {
  display: none;
}
}
.addressBox{
  display: flex!important;
  justify-content: space-between;
  margin-bottom: 10px;
  .title{
    margin: 0!important;
  }
}
.FKbox{
  /deep/ .el-form-item--mini.el-form-item{
    margin: 4px;
    margin-bottom: 16px;
  }
}
.box{
  display: flex;
  flex-wrap: wrap;
  .imgBox{
    display: flex;
      margin-right:30px;
    flex-direction: column;
    width: 320px;
    /deep/.el-upload--picture-card{
          width: 320px;
    height: 200px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../assets/images/upload1.png);
    background-size: 320px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 320px;
    height: 200px;
  }
}
.detailBox .el-form-item span{
  display:inline-block;
  width: 150px;
}
.detailBox img{
   width: 320px;
    height: 200px;
}
.detailBox /deep/ .el-date-editor--date .el-input__inner{
  border: none;
  font-size: 14px;
}
.jiaoyan .inpBox /deep/.el-date-editor .el-input__inner{
  width: 150px;
}
.redBtn{
  width:60px;
  height:28px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  background-color: red;
  border-radius: 5px;
  font-size:14px;
  margin:0 auto;
}
.greenBtn{
  width:60px;
  height:28px;
  text-align: center;
  line-height: 28px;
  color: #fff;
  background-color: #09bb07;
  border-radius: 5px;
  font-size:14px;
  margin:0 auto;
}

</style>
